import React, { useEffect, useState } from 'react';
import { useQueryClient } from 'react-query';
import { ImageUpload } from 'components/molecules/image-upload';
import { toastService } from 'components/molecules/toast';
import { useTranslation } from 'hooks/use-translation';
import { useUser } from 'hooks/use-user';
import {
  useCompanyLogoUploadMutation,
  useCompanyUpdateMutation,
} from 'queries';
import { ACCOUNT_META_DATA_QUERY_KEY } from 'queries/account';

export const CompanyLogoChange = () => {
  const title = useTranslation('avatar.upload.success.title');
  const message = useTranslation('avatar.upload.success.content');
  const errorTitle = useTranslation('avatar.upload.error.title');
  const errorMessage = useTranslation('avatar.upload.error.content');
  const buttonText = `${useTranslation('upload_logo')}...`;
  const {
    user: {
      company: { companyLogoUrl, companyName, companyId },
    },
  } = useUser();

  const [url, setUrl] = useState<string | undefined>(companyLogoUrl);

  useEffect(() => {
    setUrl(companyLogoUrl);
  }, [companyLogoUrl]);

  const queryClient = useQueryClient();
  const { mutate, isLoading } = useCompanyUpdateMutation(companyId);
  const { mutate: upload, isLoading: isUploading } =
    useCompanyLogoUploadMutation();

  const handleUpload = ({ file }) => {
    upload(file, {
      onSuccess: (response) => {
        mutate(
          { companyLogoUrl: response.location },
          {
            onSuccess: async () => {
              setUrl(response.location);
              await queryClient.invalidateQueries(ACCOUNT_META_DATA_QUERY_KEY);
              toastService({
                title,
                message,
              }).success();
            },
          },
        );
      },
      onError: () => {
        toastService({
          title: errorTitle,
          message: errorMessage,
        }).error();
      },
    });
  };

  return (
    <ImageUpload
      onUpload={handleUpload}
      isLoading={isLoading || isUploading}
      src={url}
      alt={companyName}
      buttonText={buttonText}
      showSizeRestriction
    />
  );
};
